import React from "react";
import { Grid, Container, Box, Fab } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "shared";
import { Account } from "./components/Account";
import HcoPricingSection from "./components/HcoPricingSection";
import HcoSubscriptionSection from "./components/HcoSubscriptionSection";
import HcoEarningsSection from "./components/HcoEarningsSection";
import { Area } from "types";
import { join } from "utils/misc";
import { Search } from "@material-ui/icons";

const HealthCareOrganization: React.VFC = () => {
  const { state } = useLocation<string | undefined>();

  return (
    <div>
      <Box ml={3} my={3}>
        <Link to={join(Area.HealthCareOrganizations, state)}>
          <Fab color="secondary" size="medium" aria-label="Back to search">
            <Icon of={Search} />
          </Fab>
        </Link>
      </Box>
      <Container fixed>
        <Grid container spacing={2}>
          <Grid item zeroMinWidth md={7}>
            <Account />
          </Grid>
          <Grid item zeroMinWidth md={5}>
            <HcoPricingSection />
            <HcoSubscriptionSection />
            <HcoEarningsSection />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default HealthCareOrganization;